webpackJsonp([128903798943506],{

/***/ 345:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>I found this tidbit from the Creative Bloq: <a href=\"http://www.creativebloq.com/web-design/make-your-app-seem-faster-it-81516252\">How to make your app seem faster than it really is</a></p>","frontmatter":{"path":"/posts/7AXp","title":"How to make your app seem faster than it really is","author":"Makerimages","authorUrl":"https://makerimages.github.io/"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---posts-7-a-xp-6d3b299fd8e216f3715f.js